import React from 'react';
import PropTypes from 'prop-types';

import { FieldRichTextEditor } from './index';

class FieldRichTextEditorContainer extends React.Component {
  state = { isShowingRichTextEditor: true, isShowingFocusStyles: false };

  toggleEditorMode = () => {
    const { isShowingRichTextEditor } = this.state;
    this.setState({ isShowingRichTextEditor: !isShowingRichTextEditor });
  };

  toggleFocusStyles = () => {
    const { isShowingFocusStyles } = this.state;
    this.setState({ isShowingFocusStyles: !isShowingFocusStyles });
  };

  render() {
    const { isShowingRichTextEditor, isShowingFocusStyles } = this.state;
    const {
      input,
      meta,
      type,
      label,
      placeholder,
      maxCharacterLength,
    } = this.props;
    return (
      <FieldRichTextEditor
        toggleFocusStyles={this.toggleFocusStyles}
        isShowingFocusStyles={isShowingFocusStyles}
        input={input}
        meta={meta}
        type={type}
        label={label}
        placeholder={placeholder}
        maxCharacterLength={maxCharacterLength}
        isRichTextEditor={isShowingRichTextEditor}
        onPressEditorModeToggle={this.toggleEditorMode}
      />
    );
  }
}

FieldRichTextEditorContainer.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    asyncValidating: PropTypes.bool,
    autofilled: PropTypes.bool,
    dirty: PropTypes.bool,
    dispatch: PropTypes.func,
    form: PropTypes.string,
    initial: PropTypes.string,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
    submitting: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool,
  }).isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  maxCharacterLength: PropTypes.number.isRequired,
};
export { FieldRichTextEditorContainer };
